import { BellOff } from "lucide-react";

export const SnoozedSectionDivider = ({ count }: { count: number }) => (
  <div className="flex items-center gap-2 pt-3 pb-1 border-t border-snooze-purple-border">
    <BellOff size={14} className="text-snooze-purple shrink-0" />
    <p className="text-xs font-semibold uppercase tracking-wider text-snooze-purple">
      Snoozed ({count})
    </p>
  </div>
);
